import { render, staticRenderFns } from "./dialQuantity.vue?vue&type=template&id=131d7f24&"
import script from "./dialQuantity.vue?vue&type=script&lang=js&"
export * from "./dialQuantity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports